import SpamSelector from './SpamSelector';

export default SpamSelector;
